import { toast } from 'react-hot-toast';
import walletData from '../../../data/wallet/walletData.json';
import { formatDate, format24HourTime } from '../../../utils/formatters';

export { walletData };

/**
 * Get display title for partner or activity booking
 */
export const getBusinessTitle = (booking) => {
  if (!booking) return 'N/A';
  if (booking.type === 'Task' || booking.type === 'Activity') {
    return (
      booking.business_id?.superadmin_activity_id?.name ||
      booking.business_id?.name ||
      booking.businessDetails?.activity_name ||
      booking.businessDetails?.business_name ||
      booking.business_id?.business_name ||
      booking.package_name ||
      'Activity Experience'
    );
  }
  return (
    booking.businessDetails?.business_name ||
    booking.business_id?.business_name ||
    booking.business_id?.name ||
    'Partner Business'
  );
};

/**
 * Get display location for partner or activity booking
 */
export const getBusinessLocation = (booking) => {
  if (!booking) return '';
  if (booking.type === 'Task' || booking.type === 'Activity') {
    return (
      booking.businessDetails?.city ||
      booking.business_id?.city ||
      (Array.isArray(booking.business_id?.superadmin_activity_id?.city)
        ? booking.business_id?.superadmin_activity_id?.city[0]
        : booking.business_id?.superadmin_activity_id?.city) ||
      booking.business_id?.activity_id?.city ||
      'Srinagar'
    );
  }
  return (
    booking.businessDetails?.city ||
    booking.business_id?.city ||
    booking.business_id?.address ||
    'Srinagar'
  );
};

/**
 * Status color classes
 */
export const getStatusColor = (status) => {
  switch (status?.toUpperCase()) {
    case 'SUCCESS':
    case 'COMPLETED':
    case 'PROCESSED':
      return 'text-emerald-700 bg-emerald-50 border-emerald-200/80';
    case 'PENDING':
    case 'PROCESSING':
      return 'text-amber-700 bg-amber-50 border-amber-200/80';
    case 'FAILED':
      return 'text-rose-700 bg-rose-50 border-rose-200/80';
    default:
      return 'text-slate-600 bg-slate-50 border-slate-200';
  }
};

/**
 * Extract 5-character booking ID from transaction description or reference
 */
export const extractBookingId = (description, referenceId) => {
  const match = description?.trim().match(/[a-z0-9]{5}$/i);
  return match ? match[0].toLowerCase() : referenceId || 'N/A';
};

/**
 * Export wallet transactions to CSV
 */
export const downloadWalletCSV = (transactions) => {
  if (!transactions || transactions.length === 0) {
    toast.error('No transactions to download');
    return;
  }

  const headers = walletData.csvHeaders || ['Type', 'Description', 'Reference', 'Date', 'Status', 'Amount (INR)'];
  const csvRows = [headers.join(',')];

  transactions.forEach((tx) => {
    const formattedDate = `${formatDate(tx.createdAt)} ${format24HourTime(tx.createdAt)}`.replace(/,/g, ' ');
    const desc = (tx.description || (tx.type === 'CREDIT' ? 'Commission Earned' : 'Wallet Redemption')).replace(/,/g, '');
    const type = tx.type;
    const ref = tx.razorpayPayoutId || tx.referenceId || '';
    const status = tx.status || 'COMPLETED';
    const amount = tx.amount;

    csvRows.push([type, `"${desc}"`, `"${ref}"`, `"${formattedDate}"`, status, amount].join(','));
  });

  const csvString = csvRows.join('\n');
  const blob = new Blob([csvString], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('hidden', '');
  a.setAttribute('href', url);
  a.setAttribute('download', `trrip_wallet_transactions_${Date.now()}.csv`);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  toast.success('Transaction history downloaded as CSV');
};
